import { Component, OnInit, OnDestroy, OnChanges, SimpleChanges, Input } from '@angular/core';
import { ViewFileService } from './view-file.service';
import { buttonStatus } from '../../shared/constants/button-class';
import { Popover } from 'primeng/popover';
import { KeyMap } from '../../shared/interface/key-map.interface';
import { v4 as uuidv4 } from 'uuid';
import { TabsService } from '../../services/tabs.service';
import { Tab } from '../../services/tab';

import { Subscription } from 'rxjs';
import { ellipsisDocumentOptions } from './view-file.contant';
import { CrmDocumentType } from '../constants/enums';
import { base64ToArrayBuffer, getContentType, copy } from '../utilities/common-utilities';
import { ChangeDetectorRef } from '@angular/core';
import { TabHandlerService } from '../../services/tab-handler.service';
import { convertToLocale } from '../utilities/date-utilities';
import { ConfirmationService } from 'primeng/api';
import { MessageService } from 'primeng/api';
import { AzureLoginService } from 'src/app/services/azure-login.service';
import { RolePermissionService } from '../../common/role-permission.service';

@Component({
  standalone: false,
  selector: 'view-file',
  templateUrl: 'view-file.template.html',
  styleUrls: ['view-file.scss'],
  providers: [ViewFileService, MessageService],
})
export class ViewFileComponent implements OnInit, OnChanges, OnDestroy {
  @Input() searchParams: any;
  @Input() tabKey: string;
  @Input() isGeneric: boolean;
  @Input() parentCategory: string;
  dataList: any[];
  cols: any[];
  btnStatus: any = buttonStatus;
  selectedItem: any;
  ellipsisOptions: any[] = ellipsisDocumentOptions;
  ellipsisOptionsSec: any;
  selectedEllipsisItem: any;
  clonedRowData: KeyMap = {};
  isEditing: boolean;
  editConstant: string;
  status: any[];
  newTab: Tab;
  op: Popover;
  querySubscription: Subscription;
  downloadSubscription: any;
  fileSubscription: Subscription;
  private viewAttempt = 0;
  openFailureVisible = false;
  openFailureMessage = '';
  openFailureSteps: string[] = [];
  private failureDismissed = false;
  private ignoreFailureUntil = 0;
  private blockViewClicks = false;
  isLoading: boolean;
  downloadingSpinner: boolean;
  @Input() title = 'Documents Search Results';
  constructor(
    private viewFileService: ViewFileService,
    private tabService: TabsService,
    private chRef: ChangeDetectorRef,
    private tabHandlerService: TabHandlerService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private azureService: AzureLoginService,
    private rps: RolePermissionService,
  ) {}

  ngOnInit() {
    const deletePermissionList = ['Admin'];
    if (!deletePermissionList.includes(this.azureService.roleName)) {
      this.ellipsisOptions = this.ellipsisOptions.filter((el) => el.value !== 'delete');
    }
    this.editConstant = uuidv4();
    this.status = [
      { label: 'Active', value: 'Active' },
      { label: 'Terminated', value: 'Terminated' },
    ];
    this.cols = [
      { field: 'fileName', header: 'FILE_NAME' },
      { field: 'description', header: 'DESCRIPTION' },
      { field: 'uploadedDate', header: 'UPLOADED DATE' },
      { field: 'uploadedBy', header: 'UPLOADED BY' },
      { field: 'action', header: 'ACTION' },
    ];
    if (this.isGeneric) {
      this.cols.push({ field: 'uploadState', header: 'UPLOAD STATE' });
      this.cols.push({ field: 'uploadProcessState', header: 'STATUS' });
    }
    this.downloadingSpinner = false;
    this.isLoading = true;
    if (this.searchParams) {
      this.getViewFile();
      this.tabHandlerService.selectedTab.subscribe({
        next: (tab) => {
          if (this.tabKey === tab) {
            this.isLoading = true;
            this.getViewFile();
          }
        },
      });
    }
    this.doEvaluateRolePermissions();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes.searchParams &&
      !changes.searchParams.firstChange &&
      (this.isGeneric || this.searchParams?.identifierId)
    ) {
      this.isLoading = true;
      this.getViewFile();
    }
  }

  private doEvaluateRolePermissions() {
    this.ellipsisOptionsSec = {
      type: 'three-dots',
      operation: 'READ-DELETE',
      permission: 'Documents',
      category: this.parentCategory,
    };
    this.ellipsisOptions = this.rps.evaluate(this.ellipsisOptionsSec, this.ellipsisOptions);
    if (this.isGeneric) {
      this.ellipsisOptions = this.ellipsisOptions.filter((el) => el.value !== 'delete');
    }
  }

  getViewFile() {
    if (!this.isGeneric && !this.searchParams?.identifierId) {
      this.dataList = [];
      this.isLoading = false;
      return;
    }

    if (this.querySubscription) {
      this.querySubscription.unsubscribe();
    }

    let attachmentType;
    if (this.searchParams.attachmentsType) {
      attachmentType =
        this.searchParams.attachmentsType.key === 'Import Contracts'
          ? { key: 'Customer' }
          : this.searchParams.attachmentsType;
    }
    this.querySubscription = this.viewFileService
      .getViewFileSearchResult(
        this.searchParams,
        this.searchParams.attachmentsType
          ? this.searchParams.attachmentsType.value
          : CrmDocumentType.Agent,
        attachmentType,
      )
      .subscribe(({ data, loading }: any) => {
        this.isLoading = loading;
        if (!data?.getFileAttachments) {
          this.dataList = [];
          return;
        }

        const getFileAttachments = copy(data.getFileAttachments);
        const modifedData = (getFileAttachments || []).map((item) => {
          item.fileState = 0;
          if (item.uploadProcessState === 0) {
            item.uploadProcessState = 'Processing';
          }
          if (item.uploadProcessState === 1) {
            item.uploadProcessState = 'Succesfully uploaded';

            if (item.validationResults) {
              item.uploadProcessState += this.getStatusMessage(item.validationResults);
            }
          }
          if (item.uploadProcessState === 2) {
            item.fileState = 2;
            item.uploadProcessState = 'Failed '; /* + item.failedValidationS3URL; */
          }
          if (item.uploadState) {
            item.uploadState = 'Valid';
          } else {
            item.uploadState = 'Invalid';
          }
          item.uploadedDate = convertToLocale(item.uploadedDate);
          return { ...item };
        });
        this.dataList = [...modifedData];
      });
  }

  onActionClick(event: Event, rowData: any, option: { callback?: string }) {
    if (this.blockViewClicks || this.openFailureVisible || Date.now() < this.ignoreFailureUntil) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    this.selectedItem = rowData;
    const callback = option?.callback;
    if (callback && typeof this[callback] === 'function') {
      this[callback](event, null);
    }
  }

  onRowView(event, Popover: Popover) {
    if (this.blockViewClicks || this.openFailureVisible || Date.now() < this.ignoreFailureUntil) {
      return;
    }
    if (this.downloadSubscription) {
      this.downloadSubscription.unsubscribe();
    }
    if (this.fileSubscription) {
      this.fileSubscription.unsubscribe();
    }
    const attempt = ++this.viewAttempt;
    this.downloadingSpinner = true;
    let urlHandled = false;
    this.downloadSubscription = this.viewFileService
      .getPreSignedUrl(this.selectedItem.attachmentsID, 'get')
      .subscribe(
        (preSignedInfo) => {
          if (!this.isCurrentAttempt(attempt)) {
            return;
          }
          const preSignedUrl = preSignedInfo?.data?.getPreSignedUrl;
          if (!preSignedUrl) {
            if (preSignedInfo?.loading) {
              return;
            }
            this.failOpen(attempt);
            return;
          }
          if (urlHandled) {
            return;
          }
          urlHandled = true;
          this.fileSubscription = this.viewFileService.getFile(preSignedUrl).subscribe(
            (response) => {
              this.openWhenReadable(attempt, response, this.resolveViewFileName(), preSignedUrl);
            },
            (err) => {
              if (!this.isCurrentAttempt(attempt)) {
                return;
              }
              try {
                const buffer = base64ToArrayBuffer(err.error.text);
                const fileName = this.resolveViewFileName();
                const file = new Blob([buffer as BlobPart], {
                  type: getContentType(null, fileName),
                });
                this.openWhenReadable(attempt, file, fileName, preSignedUrl);
              } catch {
                this.failOpen(attempt);
              }
            },
          );
        },
        () => {
          this.failOpen(attempt);
        },
      );
  }

  private openWhenReadable(attempt: number, data: Blob, fileName: string, fileUrl: string) {
    if (!this.isCurrentAttempt(attempt)) {
      return;
    }
    data
      .slice(0, 800)
      .text()
      .then((previewText) => {
        if (!this.isCurrentAttempt(attempt)) {
          return;
        }
        if (this.isStorageError(previewText)) {
          this.failOpen(attempt);
          return;
        }
        const safeName = fileName || 'document';
        const viewBlob = this.toViewableBlob(data, safeName);
        this.downloadFile(viewBlob, safeName);
        const extension = this.fileExtension(safeName);
        if (extension === 'csv' || extension === 'tsv') {
          this.openCsvTable(attempt, viewBlob, safeName);
          return;
        }
        if (!fileUrl) {
          this.showOpenFailure(attempt, 'Failed to open the file');
        } else if (this.opensInBrowser(extension, viewBlob.type)) {
          const preview = window.open(fileUrl, '_blank');
          if (!preview) {
            this.showOpenFailure(attempt, 'Allow pop-ups to open the document in a new tab');
          }
        } else {
          const preview = this.openPreviewWindow(safeName);
          if (!preview) {
            this.showOpenFailure(attempt, 'Allow pop-ups to open the document in a new tab');
          } else {
            this.writePreview(preview, safeName, viewBlob);
          }
        }
        this.downloadingSpinner = false;
        this.chRef.detectChanges();
      })
      .catch(() => this.failOpen(attempt));
  }

  private openCsvTable(attempt: number, data: Blob, fileName: string) {
    data.arrayBuffer().then((buffer) => {
      if (!this.isCurrentAttempt(attempt)) {
        return;
      }
      import('xlsx')
        .then((xlsx: any) => {
          if (!this.isCurrentAttempt(attempt)) {
            return;
          }
          const reader = xlsx.read ? xlsx : xlsx.default;
          const workbook = reader.read(new Uint8Array(buffer), { type: 'array' });
          const tables = (workbook.SheetNames || [])
            .map((name: string) => reader.utils.sheet_to_html(workbook.Sheets[name]))
            .join('');
          const page =
            `<!DOCTYPE html><html><head><meta charset="utf-8"><title>${this.escapeHtml(fileName)}</title>` +
            '<style>body{margin:16px;font-family:Segoe UI,sans-serif;font-size:13px;color:#222}' +
            'table{border-collapse:collapse} td,th{border:1px solid #c8c8c8;padding:6px 8px;white-space:nowrap}' +
            '</style></head><body>' +
            (tables || '<p>This file has no rows.</p>') +
            '</body></html>';
          const preview = window.open(
            URL.createObjectURL(new Blob([page], { type: 'text/html' })),
            '_blank',
          );
          if (!preview) {
            this.showOpenFailure(attempt, 'Allow pop-ups to open the document in a new tab');
          }
          this.downloadingSpinner = false;
          this.chRef.detectChanges();
        })
        .catch(() => this.failOpen(attempt));
    }).catch(() => this.failOpen(attempt));
  }

  private isStorageError(previewText: string): boolean {
    return (
      !!previewText &&
      previewText.includes('<Error>') &&
      (previewText.includes('<Code>AccessDenied</Code>') || previewText.includes('<Message>'))
    );
  }

  private isCurrentAttempt(attempt: number): boolean {
    return attempt === this.viewAttempt && !this.openFailureVisible;
  }

  private failOpen(attempt: number) {
    this.showOpenFailure(attempt, 'Failed to open the file');
  }

  private showOpenFailure(attempt: number, message: string) {
    if (Date.now() < this.ignoreFailureUntil || attempt !== this.viewAttempt || this.openFailureVisible) {
      return;
    }
    this.viewAttempt++;
    this.blockViewClicks = true;
    if (this.downloadSubscription) {
      this.downloadSubscription.unsubscribe();
    }
    if (this.fileSubscription) {
      this.fileSubscription.unsubscribe();
    }
    this.downloadingSpinner = false;
    this.isLoading = false;
    this.failureDismissed = false;
    this.openFailureMessage = message;
    this.openFailureSteps = [
      'Click View to try again.',
      'If a copy downloaded, open it from your downloads folder.',
      'If not, check the file type is supported and the upload succeeded.',
    ];
    this.openFailureVisible = true;
    this.chRef.detectChanges();
  }

  dismissFailureDialog(event?: Event): void {
    event?.preventDefault();
    event?.stopPropagation();
    this.openFailureVisible = false;
    this.finishFailureDismiss();
  }

  private finishFailureDismiss() {
    if (this.failureDismissed) {
      return;
    }
    this.failureDismissed = true;
    this.viewAttempt++;
    this.blockViewClicks = true;
    this.ignoreFailureUntil = Date.now() + 1000;
    this.openFailureVisible = false;
    setTimeout(() => {
      this.blockViewClicks = false;
      this.failureDismissed = false;
    }, 400);
  }

  private resolveViewFileName(): string {
    if (this.selectedItem?.fileState === 2) {
      return `Invalid_${this.selectedItem.fileName}`;
    }
    return this.selectedItem?.fileName;
  }

  private opensInBrowser(extension: string, contentType: string): boolean {
    return this.isPdf(extension, contentType) || this.isImage(extension, contentType);
  }

  private openPreviewWindow(fileName: string): Window | null {
    const url = URL.createObjectURL(
      new Blob([this.previewDocumentHtml(fileName, '<p class="opening">Opening document…</p>')], {
        type: 'text/html',
      }),
    );
    const preview = window.open(url, '_blank');
    setTimeout(() => URL.revokeObjectURL(url), 60000);
    return preview;
  }

  private writePreview(preview: Window, fileName: string, viewBlob: Blob) {
    this.writeHtmlPreview(preview, fileName, '<p class="opening">Opening document…</p>');
    const extension = this.fileExtension(fileName);

    if (extension === 'docx') {
      this.writeDocxPreview(preview, fileName, viewBlob);
      return;
    }
    if (extension === 'doc') {
      this.writeLegacyDocPreview(preview, fileName, viewBlob);
      return;
    }
    if (this.isPdf(extension, viewBlob.type)) {
      this.writeEmbeddedPreview(preview, fileName, viewBlob, 'application/pdf');
      return;
    }
    if (this.isImage(extension, viewBlob.type)) {
      this.writeImagePreview(preview, fileName, viewBlob);
      return;
    }
    if (this.isSpreadsheet(extension)) {
      this.writeSpreadsheetPreview(preview, fileName, viewBlob);
      return;
    }
    if (this.isTextPreview(extension, viewBlob.type)) {
      viewBlob.text().then((text) => {
        if (!preview.closed) {
          this.writeTextPreview(preview, fileName, text);
        }
      });
      return;
    }

    this.previewFallback(preview, fileName, viewBlob);
  }

  private downloadFile(data: Blob, fileName: string) {
    const url = URL.createObjectURL(data);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  }

  private fileExtension(fileName: string): string {
    const name = fileName || '';
    const dot = name.lastIndexOf('.');
    return dot >= 0 ? name.substring(dot + 1).toLowerCase() : '';
  }

  private isPdf(extension: string, contentType: string): boolean {
    return extension === 'pdf' || contentType === 'application/pdf';
  }

  private isImage(extension: string, contentType: string): boolean {
    return (
      ['png', 'jpg', 'jpeg', 'gif', 'webp', 'bmp', 'svg'].includes(extension) ||
      (!!contentType && contentType.startsWith('image/'))
    );
  }

  private isSpreadsheet(extension: string): boolean {
    return ['csv', 'tsv', 'xlsx', 'xls', 'xlsm', 'xlsb', 'ods'].includes(extension);
  }

  private isTextPreview(extension: string, contentType: string): boolean {
    if (['txt', 'json', 'xml', 'log', 'html', 'htm', 'md'].includes(extension)) {
      return true;
    }
    return !!contentType && contentType.startsWith('text/') && !['csv', 'tsv'].includes(extension);
  }

  private writeSpreadsheetPreview(preview: Window, fileName: string, blob: Blob) {
    blob
      .arrayBuffer()
      .then((buffer) => {
        import('xlsx')
          .then((xlsx: any) => {
            const reader = xlsx.read ? xlsx : xlsx.default;
            const workbook = reader.read(buffer, { type: 'array' });
            if (!workbook?.SheetNames?.length) {
              throw new Error('No sheets');
            }
            const sections = workbook.SheetNames.map((name: string) => {
              const table = reader.utils.sheet_to_html(workbook.Sheets[name]);
              const heading =
                workbook.SheetNames.length > 1 ? `<h2>${this.escapeHtml(name)}</h2>` : '';
              return heading + table;
            }).join('');
            if (!preview.closed) {
              this.writeHtmlPreview(preview, fileName, sections);
            }
          })
          .catch(() => this.previewFallback(preview, fileName, blob));
      })
      .catch(() => this.previewFallback(preview, fileName, blob));
  }

  private previewFallback(preview: Window, fileName: string, blob: Blob) {
    if (preview.closed) {
      return;
    }
    blob.text().then((text) => {
      if (preview.closed) {
        return;
      }
      if (this.looksLikeText(text)) {
        this.writeTextPreview(preview, fileName, text);
        return;
      }
      const mimeType = blob.type && blob.type !== 'application/octet-stream' ? blob.type : '';
      if (mimeType.startsWith('image/') || mimeType === 'application/pdf') {
        this.writeEmbeddedPreview(preview, fileName, blob, mimeType);
        return;
      }
      this.writeHtmlPreview(
        preview,
        fileName,
        `<p class="opening">${this.escapeHtml(fileName)} has been downloaded.</p>`,
      );
    });
  }

  private looksLikeText(text: string): boolean {
    if (!text) {
      return false;
    }
    const sample = text.slice(0, 4000);
    let control = 0;
    for (let i = 0; i < sample.length; i++) {
      const code = sample.charCodeAt(i);
      if (code === 0) {
        return false;
      }
      if (code < 9 || (code > 13 && code < 32)) {
        control++;
      }
    }
    return control / sample.length < 0.02;
  }

  private writeDocxPreview(preview: Window, fileName: string, blob: Blob) {
    blob.arrayBuffer().then(async (buffer) => {
      try {
        const xml = await this.readZipText(buffer, 'word/document.xml');
        if (!preview.closed) {
          if (xml) {
            this.writeHtmlPreview(preview, fileName, `<div class="doc">${this.docxXmlToHtml(xml)}</div>`);
          } else {
            this.previewFallback(preview, fileName, blob);
          }
        }
      } catch {
        this.previewFallback(preview, fileName, blob);
      }
    });
  }

  private writeLegacyDocPreview(preview: Window, fileName: string, blob: Blob) {
    blob.arrayBuffer().then((buffer) => {
      if (preview.closed) {
        return;
      }
      const text = this.extractLegacyDocText(buffer);
      if (text) {
        this.writeTextPreview(preview, fileName, text);
        return;
      }
      this.writeHtmlPreview(
        preview,
        fileName,
        `<p class="opening">${this.escapeHtml(fileName)} has been downloaded.</p>`,
      );
    });
  }

  private docxXmlToHtml(xml: string): string {
    const paragraphs = xml.split(/<w:p[\s>]/).slice(1);
    const html = paragraphs
      .map((paragraph) => {
        const texts = Array.from(paragraph.matchAll(/<w:t(?:\s[^>]*)?>([\s\S]*?)<\/w:t>/g)).map(
          (match) => this.decodeXml(match[1]),
        );
        const line = this.escapeHtml(texts.join(''));
        return `<p>${line || '&nbsp;'}</p>`;
      })
      .join('');
    return html || '<p class="opening">This Word document has no readable text.</p>';
  }

  private decodeXml(value: string): string {
    return value
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"')
      .replace(/&apos;/g, "'")
      .replace(/&amp;/g, '&');
  }

  private extractLegacyDocText(buffer: ArrayBuffer): string {
    const decoded = new TextDecoder('utf-16le').decode(buffer);
    const pieces = decoded.match(/[A-Za-z0-9][A-Za-z0-9 .,;:'"!?()\/&@#%+\-\n\r]{3,}/g) || [];
    return pieces.join('\n').replace(/\s+\n/g, '\n').trim();
  }

  private async readZipText(buffer: ArrayBuffer, entryName: string): Promise<string | null> {
    const data = new Uint8Array(buffer);
    const view = new DataView(buffer);
    let endOffset = -1;
    const scanFrom = Math.max(0, data.length - 22 - 65535);
    for (let index = data.length - 22; index >= scanFrom; index--) {
      if (view.getUint32(index, true) === 0x06054b50) {
        endOffset = index;
        break;
      }
    }
    if (endOffset < 0) {
      return null;
    }

    let cursor = view.getUint32(endOffset + 16, true);
    const directoryEnd = cursor + view.getUint32(endOffset + 12, true);
    while (cursor + 46 <= directoryEnd && cursor + 46 <= data.length) {
      if (view.getUint32(cursor, true) !== 0x02014b50) {
        break;
      }
      const method = view.getUint16(cursor + 10, true);
      const compressedSize = view.getUint32(cursor + 20, true);
      const nameLength = view.getUint16(cursor + 28, true);
      const extraLength = view.getUint16(cursor + 30, true);
      const commentLength = view.getUint16(cursor + 32, true);
      const localOffset = view.getUint32(cursor + 42, true);
      const name = new TextDecoder().decode(data.subarray(cursor + 46, cursor + 46 + nameLength));
      if (name === entryName) {
        const localNameLength = view.getUint16(localOffset + 26, true);
        const localExtraLength = view.getUint16(localOffset + 28, true);
        const start = localOffset + 30 + localNameLength + localExtraLength;
        const compressed = data.subarray(start, start + compressedSize);
        const bytes = method === 0 ? compressed : await this.inflateRaw(compressed);
        return new TextDecoder('utf-8').decode(bytes);
      }
      cursor += 46 + nameLength + extraLength + commentLength;
    }
    return null;
  }

  private async inflateRaw(compressed: Uint8Array): Promise<Uint8Array> {
    const decompression = new (window as any).DecompressionStream('deflate-raw');
    const bytes = compressed.buffer.slice(
      compressed.byteOffset,
      compressed.byteOffset + compressed.byteLength,
    ) as ArrayBuffer;
    const stream = new Blob([bytes]).stream().pipeThrough(decompression);
    const inflated = await new Response(stream).arrayBuffer();
    return new Uint8Array(inflated);
  }

  private writeImagePreview(preview: Window, fileName: string, blob: Blob) {
    const mimeType = this.imageContentType(fileName, blob.type);
    const typedBlob = blob.type === mimeType ? blob : new Blob([blob], { type: mimeType });
    const reader = new FileReader();
    reader.onload = () => {
      if (preview.closed) {
        return;
      }
      const src = String(reader.result || '');
      this.writeHtmlPreview(
        preview,
        fileName,
        `<img alt="${this.escapeHtml(fileName)}" src="${src}" />`,
      );
    };
    reader.onerror = () => this.showBlobDocument(preview, typedBlob, mimeType);
    reader.readAsDataURL(typedBlob);
  }

  private imageContentType(fileName: string, contentType: string): string {
    if (contentType && contentType.startsWith('image/')) {
      return contentType;
    }
    const types = {
      png: 'image/png',
      jpg: 'image/jpeg',
      jpeg: 'image/jpeg',
      gif: 'image/gif',
      webp: 'image/webp',
      bmp: 'image/bmp',
      svg: 'image/svg+xml',
    };
    return types[this.fileExtension(fileName)] || 'image/png';
  }

  private writeEmbeddedPreview(preview: Window, fileName: string, blob: Blob, mimeType: string) {
    this.showBlobDocument(preview, blob, mimeType);
  }

  private showBlobDocument(preview: Window, blob: Blob, mimeType: string) {
    const typedBlob = blob.type === mimeType ? blob : new Blob([blob], { type: mimeType });
    preview.location.href = URL.createObjectURL(typedBlob);
  }

  private writeTextPreview(preview: Window, fileName: string, text: string) {
    this.writeHtmlPreview(
      preview,
      fileName,
      `<pre id="file-content"></pre><script>document.getElementById('file-content').textContent=${JSON.stringify(
        text || '',
      )};<\/script>`,
    );
  }

  private writeHtmlPreview(preview: Window, fileName: string, bodyHtml: string) {
    const url = URL.createObjectURL(
      new Blob([this.previewDocumentHtml(fileName, bodyHtml)], { type: 'text/html' }),
    );
    preview.location.href = url;
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  }

  private previewDocumentHtml(fileName: string, bodyHtml: string): string {
    return (
      `<!DOCTYPE html><html><head><meta charset="utf-8"><title>${this.escapeHtml(fileName)}</title>` +
      '<style>html,body{margin:0;height:100%;background:#fff;color:#222}' +
      'body{font-family:Segoe UI,sans-serif;font-size:13px}' +
      'pre{margin:0;padding:16px;white-space:pre-wrap;word-break:break-word;font-family:Consolas,Menlo,monospace}' +
      'img{max-width:100%;height:auto;display:block}' +
      'embed{width:100%;height:100%;border:0}' +
      'h2{margin:16px;font-size:16px}' +
      '.doc p{margin:8px 16px;line-height:1.45}' +
      'table{border-collapse:collapse;margin:16px}' +
      'td,th{border:1px solid #ccc;padding:4px 8px;vertical-align:top}' +
      '.opening{padding:16px}</style></head><body>' +
      bodyHtml +
      '</body></html>'
    );
  }

  private escapeHtml(value: string): string {
    return value
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  private toViewableBlob(data: Blob, fileName: string): Blob {
    if (data?.type && data.type !== 'application/octet-stream') {
      return data;
    }
    return new Blob([data], { type: getContentType(null, fileName) });
  }

  onRowDelete(event, Popover: Popover) {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to delete this Document ?',
      accept: () => {
        this.isLoading = true;
        this.viewFileService.deleteAttachment(this.selectedItem.attachmentsID).subscribe(
          (isDeleted) => {
            this.isLoading = false;
            if (isDeleted) {
              this.messageService.add({
                severity: 'success',
                summary: 'Success',
                detail: `Successfully deleted document`,
              });
            } else {
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: `Failed to delete document`,
              });
            }
            this.isLoading = true;
            this.getViewFile();
          },
          (err) => {
            this.isLoading = false;
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: `Failed to delete document`,
            });
          },
        );
        if (Popover) {
          Popover.hide();
        }
      },
    });
  }

  ngOnDestroy() {
    if (this.querySubscription) {
      this.querySubscription.unsubscribe();
    }
    if (this.downloadSubscription) {
      this.downloadSubscription.unsubscribe();
    }
    if (this.fileSubscription) {
      this.fileSubscription.unsubscribe();
    }
  }

  showConfirmationMsg(header, message) {
    this.confirmationService.confirm({
      header,
      message,
      rejectVisible: false,
      acceptLabel: 'OK',
    });
    this.isLoading = false;
  }

  getStatusMessage(status) {
    let statusMessage = '';
    if (typeof status === 'string') {
      try {
        status = JSON.parse(status);
      } catch {
        status = undefined;
      }
    }
    if (status && status.importSummary) {
      if (
        status.importSummary.hasOwnProperty('totalRecordsImported') &&
        status.importSummary.hasOwnProperty('totalSubmitForPayment') &&
        status.importSummary.hasOwnProperty('totalApprovedForPayment')
      ) {
        const totalRecord = `Record Imported: ${status.importSummary.totalRecordsImported}`;
        const totalSubPay = `Submitted for Payment: ${status.importSummary.totalSubmitForPayment}`;
        const totalAppPay = `Approved For Payment: ${status.importSummary.totalApprovedForPayment}`;
        statusMessage = '\n' + [totalRecord, totalSubPay, totalAppPay].join('\n');
      }
    } else if (status && (status.contractsCreated || status.createdContractsNum)) {
      let numberCreated = status.contractsCreated;
      if (!numberCreated) {
        numberCreated = status.createdContractsNum;
      }
      const totalRecords = `Contracts Imported: ${numberCreated ? numberCreated : 'NA'}`;
      const totalDealerCost = `DealerCost : $${status.dealerCost ? status.dealerCost : 'NA'}`;
      statusMessage = '\n' + [totalRecords, totalDealerCost].join('\n');
    }
    return statusMessage;
  }
}
